module.exports = __webpack_public_path__ + "static/img/no1_bg.6c7e3690.png";